// extracted by mini-css-extract-plugin
export var activateLink = "confirm-email-module--activate-link--GUchs";
export var confirmButton = "confirm-email-module--confirm-button--mxr4a";
export var confirmMail = "confirm-email-module--confirm-mail--j1wXx";
export var envelope = "confirm-email-module--envelope--nqEOM";
export var inactiveAccount = "confirm-email-module--inactive-account--fN7JH";
export var title = "confirm-email-module--title--PuzCh";